import PaginationTable from "../../molecules/PaginationTable";
import { Link } from "react-router-dom";
import styles from "./index.module.scss";

const ReportTableBox = ({
  trackingSysId,
  titleReport,
  items,
  totalPages,
  pageNum,
  setPageNum,
  quantityItemsPerPage,
  setQuantityItemsPerPage,
  labelQuantityItemsPerPage,
  messageDateNotFilled,
}) => {
  return (
    <div className={styles.ReportTable}>
      <div className={styles.Formbox}>
        <h3 className={styles.TitleReport}>{titleReport}</h3>
        <table className={`table table-striped`}>
          <thead>
            <tr>
              <th scope="col" className={styles.HeadCol}>
                House
              </th>
              <th scope="col" className={styles.HeadCol}>
                {messageDateNotFilled}
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index} className={styles.RowTable}>
                <td>
                  <Link
                    to={`/cisco?trackingSysId=${trackingSysId}&houseNum=${item.houseNum}&houseYear=${item.houseAno}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.TextHouse}
                  >
                    {item.houseNum}/{item.houseAno}
                  </Link>
                </td>
                <td>
                  <div className={styles.TextHouseFields}>
                    {item.houseFields.map((text, index) => (
                      <p key={index}>{text}</p>
                    ))}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <PaginationTable
        totalPages={totalPages}
        currentPage={pageNum}
        onPageChange={setPageNum}
        quantityItemsPerPage={quantityItemsPerPage}
        setQuantityItemsPerPage={setQuantityItemsPerPage}
        labelQuantityItemsPerPage={labelQuantityItemsPerPage}
      />
    </div>
  );
};

export default ReportTableBox;
